const $ = require('jquery')
const Vue = require('vue')

Vue.component('form-check', {
    props: {
        label: {
            type: String
        },
        model: {
            twoWay: true,
            default: false
        },
        compact: {
            default: false
        },
        onChange: {
            type: Function,
            default: () => {
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            fieldName: ''
        }
    },
    ready () {
        this.fieldName = this._props.model.raw

        this.render()
    },
    methods: {
        changed (evt) {
            if (this.onChange) {
                this.onChange(evt.target.checked)
            }
        },
        render () {
            $(this.$els.checkBox).uniform()
        }
    },
    watch: {
        disabled () {
            this.render()
        },
        model () {
            this.render()
        },
        label () {
            this.render()
        }
    },
    computed: {
        groupStyle () {
            if (this.compact) {
                return {
                    marginBottom: 0
                }
            }

            return {}
        }
    },
    template: `
            <div class="form-group form-check" :style="groupStyle">
                <label>
                    <input
                        v-el:check-box
                        :disabled="disabled"
                        @change="changed"
                        type="checkbox"
                        v-model="model"
                        v-bind:data-field="fieldName">
                        <slot name="label">
                            {{{ label }}}
                        </slot>
                </label>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/check.js